import * as Request from '../Request';

const Exam = {
  listLibrary: (data) => {
    return Request.post('/edu/questionSet/list', data);
  },
  saveLibrary: (data) => {
    return Request.post('/edu/questionSet/save', data);
  },
  updateLibrary: (data) => {
    return Request.put('/edu/questionSet/update', data);
  },
  delLibrary: (data) => {
    return Request.del('/edu/questionSet/delete', data);
  },
  list: (data) => {
    return Request.post('/edu/question/list', data);
  },
  save: (data) => {
    return Request.post('/edu/question/save', data);
  },
  update: (data) => {
    return Request.put('/edu/question/update', data);
  },
  del: (data) => {
    return Request.del('/edu/question/delete', data);
  }
}
export default Exam
